$(document).ready(function(){

/* Cart terms checkbox */
  $(document).on('change','.cart__footer-wrapper #cart-accept-terms-condition',function(){
    if($(this).is(':checked')){
     $('.cart__footer-wrapper .cart__dynamic-checkout-buttons,.cart__footer-wrapper .cart__checkout-button').removeClass('disabled');
    }else{
      $('.cart__footer-wrapper .cart__dynamic-checkout-buttons,.cart__footer-wrapper .cart__checkout-button').addClass('disabled');
    }
  });

  $(document).on('change','.drawer__footer #cart-drawer-accept-terms-condition',function(){
    if($(this).is(':checked')){
     $('.drawer__footer .cart__checkout-button').removeClass('disabled');
    }else{
      $('.drawer__footer .cart__checkout-button').addClass('disabled');
    }
  });
  /* Cart terms checkbox */

});                  